import { useLayoutEffect, useState } from 'react';
import DeepLinkButton from './message-actions-buttons/DeepLinkButton';
import MessageActions from './MessageActions';
import ForwardButton from './message-actions-buttons/ForwardButton';
import HideButton from './message-actions-buttons/HideButton';
import ReplyAllButton from './message-actions-buttons/ReplyAllButton';
import ReplyButton from './message-actions-buttons/ReplyButton';
import UnhideButton from './message-actions-buttons/UnhideButton';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const SMALL_SCREEN_WIDTH = 900;
const MessageActionsStandard = props => {
  const {
    allowCommunicatorButtons,
    allowHiddenMessages,
    allowUnhidingMessage,
    allowReplies,
    genericChannelId,
    hiddenBy,
    messageHidingEnabled,
    hasMultipleRecipients,
    messageId,
    onClickToHideMessage,
    onClickToShowMessage,
    onClickToReplyAll,
    onClickToReply,
    onClickToForward,
    children,
    shouldCollapseActions = false,
    ungatedForThreadMessagesUIImprovements = false
  } = props;
  const hiddenMessageActor = hiddenBy === null || hiddenBy === void 0 ? void 0 : hiddenBy.get('actorId');
  const isHiddenMessage = !!hiddenMessageActor;
  const showDeepLinkButton = !isHiddenMessage;
  const showReplyAllButton = !isHiddenMessage && allowReplies && hasMultipleRecipients && onClickToReplyAll && allowCommunicatorButtons;
  const showReplyButton = !isHiddenMessage && allowReplies && onClickToReply && allowCommunicatorButtons;
  const showForwardButton = !isHiddenMessage && onClickToForward && allowCommunicatorButtons;
  const showUnhideButton = allowHiddenMessages && isHiddenMessage;
  const showHideButton = messageHidingEnabled && !isHiddenMessage;
  const [shouldCollapseFromWidth, setShouldCollapseFromWidth] = useState(false);
  useLayoutEffect(() => {
    if (window.innerWidth < SMALL_SCREEN_WIDTH && ungatedForThreadMessagesUIImprovements) {
      setShouldCollapseFromWidth(true);
    } else {
      setShouldCollapseFromWidth(false);
    }
  }, [ungatedForThreadMessagesUIImprovements]);
  return /*#__PURE__*/_jsxs(MessageActions, {
    genericChannelId: genericChannelId,
    collapsed: shouldCollapseActions || shouldCollapseFromWidth,
    children: [showReplyAllButton && /*#__PURE__*/_jsx(ReplyAllButton, {
      onClick: onClickToReplyAll,
      genericChannelId: genericChannelId,
      collapsed: shouldCollapseActions || shouldCollapseFromWidth
    }), showReplyButton && /*#__PURE__*/_jsx(ReplyButton, {
      onClick: onClickToReply,
      genericChannelId: genericChannelId,
      collapsed: shouldCollapseActions || shouldCollapseFromWidth
    }), showForwardButton && /*#__PURE__*/_jsx(ForwardButton, {
      onClick: onClickToForward,
      genericChannelId: genericChannelId,
      collapsed: shouldCollapseActions || shouldCollapseFromWidth
    }), showDeepLinkButton && /*#__PURE__*/_jsx(DeepLinkButton, {
      messageId: messageId,
      genericChannelId: genericChannelId,
      collapsed: true
    }), showUnhideButton && /*#__PURE__*/_jsx(UnhideButton, {
      collapsed: true,
      unhideEnabled: allowUnhidingMessage,
      genericChannelId: genericChannelId,
      onClick: onClickToShowMessage
    }), showHideButton && /*#__PURE__*/_jsx(HideButton, {
      collapsed: true,
      genericChannelId: genericChannelId,
      onClick: onClickToHideMessage
    }), children]
  });
};
MessageActionsStandard.displayName = 'MessageActionsStandard';
export default MessageActionsStandard;